module.exports = __webpack_public_path__ + "static/av-store-975726fe09e92b248e0d71b4bb73b011.png";